<template>
    <div>
        <div class="bg" v-if="isShow"></div>
        <div class="tz-box" v-if="isShow">
            <div class="tip-title tip-su" v-if="isSuccess==='success'">&nbsp;</div>
            <div class="tip-title tip-error" v-if="isSuccess==='error'">&nbsp;</div>
            <div class="tip-title" v-if="isSuccess==='save'">&nbsp;</div>
            <div class="tip-text">{{tip}}</div>
        </div>
    </div>
</template>

<script>
	export default {
		name : "tip",
      props:{
		isShow:false,
        tip:{
            type: String,
            default:'即将上线，敬请期待'
        },
        isSuccess:{
            type: String,
            default: 'save'
        }
      }
	}
</script>

<style scoped>
    /*======提示框========*/
    .bg{
        width: 100%;
        height: 100%;
        position: fixed;
        top: 0;
        left: 0;
        z-index: 9999;
        background-color: #05123E;
        opacity: 0.5;
    }
    .tz-box {
        z-index: 99999;
        background:rgba(9,16,40,0.8);
        border-radius:8px;
        opacity:0.89;
        width: 500px;
        height: 300px;
        padding: 10px;
        position: fixed;
        top: calc((100% - 300px) / 2);
        left: calc((100% - 400px) / 2);
        color: #fff;
    }
    .tip-title {
        width: 120px;
        height: 120px;
        text-align: left;
        margin:60px auto 20px;
        background-image: url('./../assets/img_comingsoon@2x.png');
        background-repeat: no-repeat;
        background-size:cover;
    }
    .tip-su {
        background-image: url('./../assets/su.png');
    }
    .tip-error {
        background-image: url('./../assets/error.png');
    }
    .tip-text {
        text-align: center;
        font-size:18px;
    }
    /*======提示框========*/
</style>